import React, { useContext, useState, useEffect, MouseEventHandler } from 'react';
import { UserContext } from '../UserContext';
import { PageContext } from '../PageContext';
import { Col, Container, Row } from 'reactstrap';
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridCellProps, GridDataStateChangeEvent, GridPageChangeEvent,getSelectedState,GridSelectionChangeEvent} from '@progress/kendo-react-grid';
import { Input,Checkbox, CheckboxChangeEvent, InputChangeEvent, Switch, SwitchChangeEvent } from '@progress/kendo-react-inputs';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { upStatusDataItem, StatusDataItem } from '../../services/interfaces';
import { deleteStatus, saveGroupPub, saveStatus } from '../../services/apiAdminService';
import { getStatusList } from '../../services/apiService';
import { process, State, DataResult } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import { PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Label } from '@progress/kendo-react-labels';
import { data } from 'react-router-dom';
import { ConfirmDialog } from '../ConfirmDialog';

interface PageState {
    skip: number;
    take: number;
}

const initialPageState: PageState = { skip: 0, take: 20 };

const initialDataState: State = {
    sort: [{ field: 'groupName', dir: 'asc' },{ field: 'pubName', dir: 'asc' }],
};

interface editProps{
    status:StatusDataItem,
    title: string,
    onClose: () => void;
    action:string
}

export interface NewStatus
{
    adminOnly:boolean;
    atolView:boolean;
    autoEps:boolean;
    color:string;
    displayOrder:string;
    epsFail:string;
    epsPreflight:string;
    epsSuccess:string;
    readonly:boolean;
    status:string;
    tempChar1:string;
    tempInt:number;
    userType:string;
    workflowLevel:number;
}


const EditDialog=(props:editProps)=>{

    const [newStatus, setNewStatus]= useState<NewStatus>(
        {
            adminOnly:false,
            atolView:false,
            autoEps:false,
            color:"",
            displayOrder:"",
            epsFail:"",
            epsPreflight:"",
            epsSuccess:"",
            readonly:false,
            status:"",
            tempChar1:"",
            tempInt:0,
            userType:"",
            workflowLevel:0
        }
    );
    const [dlgTitle, setDlgTitle]=useState<string>("");
    const [selectedStatus,setSelectedStatus]=useState([]);
    const [showDelConfirm, setShowDelConfirm]=useState(false);
    const [showDeleteButton, setShowDeleteButton]=useState(true);
    const [intAction,setIntAction]=useState("");

    const [pubValid, setPubValid]=useState({
        pubNum:false,
        pubName:false,
        pubSite:false
    });
    const setStatusName=(e: InputChangeEvent|string)=>{
        if (typeof(e)=="string"){
            setNewStatus({...newStatus, status: (e as string) || ''})
        }else{
            setNewStatus({...newStatus, status: (e.target.value as string) || ''})
        }        
    }

    const setUserType=(e: InputChangeEvent)=>{
        setNewStatus({...newStatus, userType: (e.value)})
    }

    const setWorkFlowLevel=(e: InputChangeEvent)=>{
        setNewStatus({...newStatus, workflowLevel: Number(e.value)})
    }

    const setDisplayOrder=(e:InputChangeEvent)=>{
        setNewStatus({...newStatus, displayOrder: (e.value)})
    }

    const setColor=(e:DropDownListChangeEvent)=>{
        setNewStatus({...newStatus, color: (e.value)})
    }

    const setReadOnly=(e:SwitchChangeEvent)=>{
        setNewStatus({...newStatus, readonly: (e.value)})
    }

    const setAdminOnly=(e:SwitchChangeEvent)=>{
        setNewStatus({...newStatus, adminOnly: (e.value)})
    }
    
    const setRouter=(e:SwitchChangeEvent)=>{
        setNewStatus({...newStatus, autoEps: (e.value)})
    }
    const setATOLView=(e:SwitchChangeEvent)=>{
        setNewStatus({...newStatus, atolView: (e.value)})
    }



    const validateStatus= async()=>{
        var statusValid={
            status:false,
            displayOrder:false,
            userType:true
        }
        if (newStatus.status!=""){
            statusValid.status=true;
        }
        if (newStatus.displayOrder!==""){
            statusValid.displayOrder=true;            
        }
        // if (newStatus.userType!==""){
        //     statusValid.userType=true;
        // }
        return statusValid;
    }
    

    const viewDeleteButton=()=>{
        setShowDeleteButton(true);
    }

    const hideDeleteButton=()=>{
        setShowDeleteButton(false);
    }


    const viewDelConfirm=()=>{
        setShowDelConfirm(true);
    }

    const hideDelConfirm=()=>{
        setShowDelConfirm(false);
    }



    const deleteThisStatus=()=>{
        if (props.action=="Edit"){
            const status = newStatus.status;
            const displayOrder = newStatus.displayOrder;
            const userType = newStatus.userType;
            if (status!=""){
               deleteStatus(status, displayOrder,userType);
            }
        }        
        hideDelConfirm();
        props.onClose();
    }



    const saveThisStatus= async ()=>{

        var oStatus;
        var oDisplayOrder;
        var oUserType;
        console.log(newStatus);
        validateStatus().then((statValid)=>{
             if (statValid.status===true && statValid.status===true && statValid.userType===true){
                 if (intAction==="Edit"){
                    //edit existing pub
                    oStatus=props.status.status;
                    oDisplayOrder = props.status.displayOrder;
                    oUserType=props.status.userType
                 }else{
                     //create new pub
                    oStatus="";
                    oDisplayOrder = 0;
                    oUserType="";
                 }
                 var formData:upStatusDataItem = {
                    oStatus:oStatus,
                    oDisplayOrder: Number(oDisplayOrder),
                    oUserType:oUserType,
                    adminOnly:newStatus.adminOnly?1:0,
                    atolView:newStatus.atolView?1:0,
                    autoEps:newStatus.autoEps?1:0,
                    color:newStatus.color,
                    displayOrder:Number(newStatus.displayOrder),
                    epsFail:newStatus.epsFail,
                    epsPreflight:newStatus.epsPreflight,
                    epsSuccess:newStatus.epsSuccess,
                    readonly:newStatus.readonly?1:0,
                    status:newStatus.status,
                    tempChar1:newStatus.tempChar1,
                    tempInt:newStatus.tempInt,
                    userType:newStatus.userType,
                    workflowLevel:newStatus.workflowLevel
                };
                 console.log(formData);
                 saveStatus(formData).then((data)=>{
                     console.log(data);
                     props.onClose();
                 });    
             }else{
                 console.log("Missing fields");
             }    
        });
        
    }

    useEffect(() => {  
        setDlgTitle(props.title);
        console.log(props.status); 
        if (props.status){
            setNewStatus({
                adminOnly:props.status.adminOnly,
                atolView:props.status.atolView,
                autoEps:props.status.autoEps,
                color:props.status.color,
                displayOrder:props.status.displayOrder,
                epsFail:props.status.epsFail,
                epsPreflight:props.status.epsPreflight,
                epsSuccess:props.status.epsSuccess,
                readonly:props.status.readonly,
                status:props.status.status,
                tempChar1:props.status.tempChar1,
                tempInt:props.status.tempInt,
                userType:props.status.userType,
                workflowLevel:props.status.workflowLevel
            })            
        }
        setIntAction(props.action);
        if (props.action==="Edit"){
            viewDeleteButton();
        }else{
            hideDeleteButton();
        }
    },[]);
    return(
        <>
        <Dialog title={dlgTitle} onClose={props.onClose} width={700} height={"70vh"}>
            {showDelConfirm?<ConfirmDialog title='Delete Group Publication Entry' message='This will permanently delete the selected group publication entry. This can not be undone. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDelConfirm} onConfirm={deleteThisStatus}  ></ConfirmDialog>:null}

            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Status:</Label></Col>
                <Col xs="9"><Input value={newStatus.status} onChange={setStatusName} maxLength={16} required={true}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Display Order:</Label></Col>
                <Col xs="9"><Input value={newStatus.displayOrder} onChange={setDisplayOrder} required={true}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Color:</Label></Col>
                <Col xs="9"><DropDownList data={["WHITE", "RED", "BLUE GREEN", "PURPLE", "ORANGE", "BROWN", "TEAL", "MAGENTA", "GRAY", "BLUE", "GREEN", "LIGHT GREEN", "LIGHT RED", "LIGHT BLUE", "DARK GREEN", "DARK RED", "DARK BLUE", "LIGHT GRAY", "PINK", "YELLOW", "PEA GREEN", "OFF WHITE"]} value={newStatus.color} onChange={setColor} fillMode={"outline"}></DropDownList></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Workflow Level:</Label></Col>
                <Col xs="9"><Input value={newStatus.workflowLevel} onChange={setWorkFlowLevel}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>User Type:</Label></Col>
                <Col xs="9"><Input value={newStatus.userType} onChange={setUserType}></Input></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"></Col>
                <Col xs="9"><Switch checked={newStatus.readonly} onChange={setReadOnly}></Switch>&emsp;<Label className='mb-2'> Read Only</Label></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"></Col>
                <Col xs="9"><Switch checked={newStatus.adminOnly} onChange={setAdminOnly}></Switch>&emsp;<Label className='mb-2'> Admin Only</Label></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"></Col>
                <Col xs="9"><Switch checked={newStatus.autoEps} onChange={setRouter}></Switch>&emsp;<Label className='mb-2'> Router Status</Label></Col>
            </Row>
             <Row className='mb-3'>
                <Col xs="3"></Col>
                <Col xs="9"><Switch checked={newStatus.atolView} onChange={setATOLView}></Switch>&emsp;<Label className='mb-2'> ATOL Status</Label></Col>
            </Row>
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={props.onClose}>Cancel</Button>
                <Button themeColor={"primary"} onClick={saveThisStatus}>Save</Button>
                {showDeleteButton?<Button themeColor={"warning"} onClick={viewDelConfirm}>Delete</Button>:null}
            </DialogActionsBar>
        </Dialog>
        </>
    )
}

export default function AdminStatus (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    const user = userContext?.user;
    const [statuses, setStatuses] = useState([]);
    const [statusSelected, setStatusSelected]=useState<StatusDataItem>();
    const [showEditDialog,setShowEditDialog]=useState(false);
    const [title,setTitle]=useState("");
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(statuses,dataState));
    const [page, setPage] = React.useState<PageState>(initialPageState);
    const [action,setAction]=useState("Edit");
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});

    const idGetter = getter('pubNum');

    const setSelectedPub=(status:StatusDataItem)=>{
        setStatusSelected(status);
    }

    const hideEditDialog=()=>{
        setShowEditDialog(false);
        getStatuses();
    }

    const newEditDialog=(e: React.MouseEvent<HTMLButtonElement>)=>{
        setAction("New");
        setTitle("New Status");
        setStatusSelected( {
            adminOnly:false,
            atolView:false,
            autoEps:false,
            color:"",
            displayOrder:"",
            epsFail:"",
            epsPreflight:"",
            epsSuccess:"",
            readonly:false,
            status:"",
            tempChar1:"",
            tempInt:0,
            userType:"",
            workflowLevel:0
        })
        setShowEditDialog(true);
    }



    const getStatuses=()=>{
        getStatusList().then(data=>{
            setStatuses(data);
            setDataResult(process(data, dataState));
        })
    }

    const onDataStateChange = (e: GridDataStateChangeEvent) => {
        setDataState(e.dataState);
        setDataResult(process(statuses, e.dataState));
    };
    const pageChange = (event: GridPageChangeEvent) => {
        const targetEvent = event.targetEvent as PagerTargetEvent;        
        setPage({
            ...event.page,
            take:20
        });
    }

    const onSelectionChange = (event: GridSelectionChangeEvent) => {
        console.log("Selection changed");
        console.log(event.startDataItem);
        const status:StatusDataItem=event.startDataItem;
        setSelectedPub(status);

        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey: "status"
        });
        console.log(Object.keys(newSelectedState)[0]);
        setSelectedState(newSelectedState);
    };

    useEffect(()=>{
        if (statusSelected){
            setTitle("Status Configuration for: " + statusSelected?.status);
            setShowEditDialog(true);
        }
    },[statusSelected])
   
    useEffect(() => {   
        if (user?.loggedIn){
            getStatuses();
        }else{
            window.location.replace("/Login");
        }
    }, []);

    return (
        <>
        {user?.loggedIn && user.type==5 ?
        <Container fluid>
            <h2>Status Management</h2>
            <Toolbar>
                <Button title="New Status" themeColor={'primary'} type="button" onClick={newEditDialog}>
                    New Status
                </Button>       
            </Toolbar>
            <Grid
                data={(dataResult.data.slice(page.skip, page.take + page.skip))?.map((item)=>({
                    ...item, 'selected':selectedState[idGetter(item)]
                }))}
                dataItemKey='status'
                id="statusGrid"
                className='mmGrid'
                sortable={true}
                selectable={{ enabled:true, mode: 'single' }}
                pageable={{
                    buttonCount: 4,
                    info:true,                
                    pageSizeValue: 20
                }}
                {...dataState}
                onDataStateChange={onDataStateChange}
                onPageChange={pageChange}
                onSelectionChange={onSelectionChange}
                skip={page.skip}
                take={page.take}
                total={dataResult.total}
                reorderable={true}
                filterable={true}
            >
                <GridColumn field='status' title='Status' width={200} />
                <GridColumn field='displayOrder' title='Display Order'/>
                <GridColumn field='userType' title='User Type'/>
                <GridColumn field='color' title='Color'/>
                <GridColumn field='autoEps' title='Router Trigger'/>
            </Grid>
            {showEditDialog?
                <EditDialog title={title} status={statusSelected as StatusDataItem} onClose={hideEditDialog} action={action}></EditDialog>
            :null
            }
        </Container>
        : <></>}
        </>
    );
}